import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { StudentService } from 'src/app/private/services/student.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-move-to-student',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './move-to-student.component.html',
  styleUrl: './move-to-student.component.scss'
})
export class MoveToStudentComponent {

  @Output() closeDialog = new EventEmitter();
  @Input() editLeadData: any = {};
  @Output() reload = new EventEmitter<any>();
  isLoading = false;
  @Input() academicYears: any[] = [];
  @Input() departments: any[] = [];
  @Input() courses: any[] = [];
  @Input() batches: any[] = [];

  selectedAcademicYear: any = null;
  selectedDepartment: any = null;
  selectedCourse: any = null;
  selectedBatch: any = null;

  constructor(
    private api: StudentService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    console.log("editLeadData", this.editLeadData);
    this.selectedAcademicYear = this.editLeadData.academic_year_id || null;
    this.selectedDepartment = this.editLeadData.department_id || null;
    this.selectedCourse = this.editLeadData.course_id ? parseInt(this.editLeadData.course_id) : null;
    this.selectedBatch = this.editLeadData.batch_id || null;

    console.log("Selected Academic Year:", this.selectedAcademicYear);
    console.log("Selected Department:", this.selectedDepartment);
    console.log("Selected Course:", this.selectedCourse);
    console.log("Selected Batch:", this.selectedBatch);
  }

  moveToStudent() {
    if (!this.editLeadData) return;

    this.isLoading = true;

    const admission = this.editLeadData || {};
    const data = {
      organization_id: this.localStorage.getOrganizationId() || admission.organization_id,
      campus_id: this.localStorage.getCampusId() || admission.campus_id,
      admission_id: admission.admission_id || null,
      department_id: this.selectedDepartment || admission.department_id,
      academic_year: this.selectedAcademicYear || admission.academic_year_id,
      batch_id: this.selectedBatch || admission.batch_id,
      course_id: this.selectedCourse || admission.course_id,
      
      // Student Details from admission
      student_id: null, // Will be generated
      enrollment_number: admission.admission_number || null,
      registration_date: new Date().toISOString(),
      status: "Active",
      
      // Personal Information
      prefix: admission.prefix || null,
      first_name: admission.first_name,
      last_name: admission.last_name,
      email: admission.email,
      phone: admission.phone,
      country_code: admission.country_code,
      alternate_phone: admission.alternate_phone,
      date_of_birth: admission.date_of_birth,
      age: admission.age,
      gender: admission.gender,
      blood_group: admission.blood_group || null,
      nationality: admission.nationality,
      
      // Address Information
      address: admission.address,
      city: admission.city,
      state: admission.state,
      country: admission.country,
      postal_code: admission.postal_code,
      
      // Guardian Information
      guardian_name: admission.guardian_name,
      guardian_contact: admission.guardian_contact,
      
      // Academic Information
      previous_education: admission.previous_education,
      admission_type: admission.admission_type,
      category: admission.category,
      
      // Dynamic Fields
      dynamic_fields: admission.dynamic_fields || {},
      
      // Additional Information
      remarks: admission.remarks || "Student moved from admission",
      created_by: this.localStorage.getUserId(),
      created_at: new Date().toISOString()
    };

    this.api.moveToStudent(data).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: res?.message });
        this.reload.emit();
        this.closeDialog.emit();
      },
      error: (err) => {
        this.isLoading = false;
        console.error("Move to student error", err);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.error || err?.error?.message   || 'Something went wrong' });
      }
    });
  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  getFullName(user: any) {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }
}
